 
import Ajax from 'axios'
import config from "@/utils/config"
const base_url=config.context;
// const base_url="/v1";

let token= localStorage.getItem("token");
//获取token
export function getToken(){
  let data= new FormData();
  data.append("username","jsxdz");
  data.append("password","123456");
  data.append("device","pc");
  return Ajax({
    url: base_url+'/login/toLogin',
    method: "post",
    data:data
  })
}
//获取所有区域
export function getAllArea(){
  return Ajax({
    url: base_url+'/dangerinfo/all_list',
    method: "get",
    headers:{
      'token':token
    }
  })
}
//根据罩子id查询区域信息
export function getById(id) {
  return Ajax({
    url: base_url + '/dangerinfo/getById' + id,
    method: 'get',
    headers: {
      token: token
    }
  });
}
//获取所有承诺卡
export function getAllPromisecard(){
  return Ajax({
    url: base_url+'/promisecard/getAll',
    method: "get",
    headers:{
      'token':token
    }
  })
}

//获取所有应知卡
export function getAllShouldknowcaSrd(){
  return Ajax({
    url: base_url+'/shouldknowcard/getAll',
    method: "get",
    headers:{
      'token':token
    }
  })
}

//获取所有应急卡
export function getAllEmergencycard(){
  return Ajax({
    url: base_url+'/emergencycard/getAll',
    method: "get",
    headers:{
      'token':token
    }
  })
}





//获取所有box数据
export function getAllBox(){
  return Ajax({
    url: base_url+'/mapdrawinfo/list_all',
    method: "get",
    headers:{
      'token':token
    }
  })
}
//插入一个box
export function addBox(options){
  let data=options;
  return Ajax({
    url: base_url+'/mapdrawinfo/save',
    method: "post",
    data:data,
    headers:{
      'token':token
    }
  })
}
//删除一个box
export function deleteBox(options){
  let data=options;
  return Ajax.delete(base_url+`/mapdrawinfo/delete/${data.id}`,{
    headers:{
      'token':token
    }
  })
}
//编辑一个box
export function editBox(options){
  let data=options;
  return Ajax({
    url: base_url+'/mapdrawinfo/update',
    method: "post",
    data:data,
    headers:{
      'token':token
    }
  })
}

//获取罩子详情
export function getInfo(id){
  return Ajax({
    url: base_url+'/dangerinfo/get/'+id,
    method: "get",
    headers:{
      'token':token
    },
  })
}

//工艺报警罩子冒泡数据
export function findSirenTimelyDataShowOnHood(){
  return Ajax({
    // url: base_url+'/channelrecord/findSirenTimelyDataShowOnHood',
    url: base_url+'/collectionData/mapRealDataBubble',
    method: "get",
    headers:{
      'token':token
    },
    params:{
    }
  })
}


//区域详情工艺报警操作地图显示(弃用)
export function updateChannelAlarmsShowOrHide(id,showInMap){
  return Ajax({
    url: base_url+'/channelrecord/updateChannelAlarmsShowOrHide',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id: id,
      showInMap: showInMap
    }
  })
}


//区域详情工艺报警操作地图显示(新)
export function updateChannelAlarmsShowOrHideNew(id,showInBubble){
  return Ajax({
    url: base_url+'/dataCollectionPoint/show_in_bubble',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id: id,
      showInBubble: showInBubble
    }
  })
}


//区域详情工艺报警操作地图采集设备标记坐标接口(新)
export function markLongitudeAndLatitude(id,longitude,latitude){
  return Ajax({
    url: base_url+'/dataCollectionPoint/markLongitudeAndLatitude',
    method: "POST",
    headers:{
      'token':token
    },
    data:{
      id: id,
      longitude:longitude,
      latitude:latitude
    }
  })
}

//获取工艺报警信息详情(弃用)
export function getFindSirenTimelyData(curPage,limit){
  return Ajax({
    url: base_url+'/channelrecord/findSirenTimelyData',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      curPage: curPage,
      limit: limit
    }
  })
}

//查询标记过的采集设备列表(新)
export function findHasMarkPointList(){
  return Ajax({
    url: base_url+'/dataCollectionPoint/findHasMarkPointList',
    method: "get",
    headers:{
      'token':token
    },
    params:{
    }
  })
}

//查询采集点设备详细信息(新)
export function findPointDetails(id){
  return Ajax({
    url: base_url+'/dataCollectionPoint/findPointDetails',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id:id
    }
  })
}

//获取工艺报警信息详情(新)
export function getFindSirenTimelyDataNew(data){
  return Ajax({
    url: base_url+'/collectionData/real_time_data',
    method: "post",
    data:data
  })
}


//获取风险等级
export function getRiskclassification(id, curPage, limit){
  return Ajax({
    url: base_url+'/riskControl/list_all',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      dangerInfoId: id,
      curPage: curPage,
      limit: limit
    }
  })
}
//查询危险因素
export function getHarmfulfactorsinvestigation(id, curPage, limit){
  return Ajax({
    url: base_url+'/riskIdentify/getRiskIdentifyPage',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      dangerInfoId: id,
      curPage: curPage,
      limit: limit
    }
  })
}
//查询作业列表
export function getWorkPermit(id){
  return Ajax({
    url: base_url+'/workPermit/getByDangerId',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id:id,
      // curPage:1,
      // limit:10
    }
  })
}
//查询巡检记录
export function getInspectionrecord(id){
  return Ajax({
    url: base_url+'/inspectionrecord/getByDangerId',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id:id,
      // curPage:1,
      // limit:10
    }
  })
}
//查询报警记录(弃用)
export function getChannelrecord(data){
  return Ajax({
    url: base_url+'/channelrecord/list_all',
    method: "post",
    data:data
  })
}

//查询报警记录(新)
export function getChannelrecordNew(data){
  return Ajax({
    url: base_url+'/alertData/map_alert_list',
    method: "post",
    data:data
  })
}


//区域数量
export function getResultCount(id){
  return Ajax({
    url: base_url+'/application/getResultCount',
    method: "get",
    headers:{
      'token':token
    },
    params:{
      id:id,
      // curPage:1,
      // limit:10
    }
  })
}
